type Props = {
  word: string;
  selected: boolean;
  onToggle: () => void;
};

export function WordCell({ word, selected, onToggle }: Props): JSX.Element {
  const base =
    'flex items-center justify-center px-2.5 rounded-xl w-full h-[70px] self-center min-w-0 text-center transition-colors';
  const tone = selected
    ? 'bg-primary border-primary text-canvas'
    : 'bg-canvas border-border text-secondary';
  return (
    <button
      type="button"
      aria-pressed={selected}
      onClick={onToggle}
      // The project's styles.css resets `button { border: 0 }`, so we have to
      // restore width+style inline. Color comes from the `border-*` class.
      style={{ borderWidth: '1px', borderStyle: 'solid' }}
      className={`${base} ${tone}`}
    >
      <span className="text-word-sm break-words leading-tight">{word}</span>
    </button>
  );
}
